module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content pd-025"
  }, [_c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field"
  }, [_vm._m(1), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入客户经理名字"
    },
    model: {
      value: (_vm.formItem.referrer),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "referrer", $$v)
      },
      expression: "formItem.referrer"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.showCategoryPop = true
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("主营类目 ")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.businessTypeName ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.businessTypeName || '请选择主营类目'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("营业时间")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入营业时间"
    },
    model: {
      value: (_vm.formItem.businessTime),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "businessTime", $$v)
      },
      expression: "formItem.businessTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("门店名称")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入门店名称"
    },
    model: {
      value: (_vm.formItem.shopName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "shopName", $$v)
      },
      expression: "formItem.shopName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("服务电话")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "tel",
      "clearable": true,
      "placeholder": "请输入服务电话"
    },
    model: {
      value: (_vm.formItem.serviceTel),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "serviceTel", $$v)
      },
      expression: "formItem.serviceTel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("负责人")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入负责人"
    },
    model: {
      value: (_vm.formItem.linkor),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "linkor", $$v)
      },
      expression: "formItem.linkor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("负责人电话")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "tel",
      "clearable": true,
      "placeholder": "请输入负责人电话"
    },
    model: {
      value: (_vm.formItem.linkTelephone),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "linkTelephone", $$v)
      },
      expression: "formItem.linkTelephone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.$refs.pickerArea.popupShow = true
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("所在地区 ")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.areaname ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.areaname.split(",").join(" ") || '请选择所在地区'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.$refs.chooseMap.popupShow = true
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("经纬度")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.lng && _vm.formItem.lat),
      expression: "formItem.lng && formItem.lat"
    }],
    staticClass: "field-content color-333"
  }, [_vm._v(_vm._s(_vm.formItem.lng + ' , ' + _vm.formItem.lat))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formItem.lng && _vm.formItem.lat)),
      expression: "!(formItem.lng && formItem.lat)"
    }],
    staticClass: "field-content color-999"
  }, [_vm._v("请选择所在经纬度")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-field",
    staticStyle: {
      "align-items": "baseline"
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "textarea",
      "autosize": "",
      "clearable": true,
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formItem.address),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "address", $$v)
      },
      expression: "formItem.address"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("下一步")])]), _vm._v(" "), _c('pickerArea', {
    ref: "pickerArea",
    on: {
      "change": _vm.areaConfirm
    }
  }), _vm._v(" "), _c('chooseMap', {
    ref: "chooseMap",
    attrs: {
      "lng": Number(_vm.formItem.lng),
      "lat": Number(_vm.formItem.lat)
    },
    on: {
      "sure": _vm.mapConfirm
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCategoryPop),
      callback: function($$v) {
        _vm.showCategoryPop = $$v
      },
      expression: "showCategoryPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns,
      "value-key": "categoryName"
    },
    on: {
      "cancel": function($event) {
        _vm.showCategoryPop = false
      },
      "change": _vm.onChange,
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-register-state"
  }, [_c('div', {
    staticClass: "text color-main"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinlv color-main"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-999"
  }, [_vm._v("公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinhei color-999"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-999"
  }, [_vm._v("店铺设置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-32 color-333 left"
  }, [_vm._v("客户经理"), _c('br'), _vm._v("名字")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7456db6a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/baseInfo.vue
// module id = 5Ahh
// module chunks = 51